module.exports = __webpack_public_path__ + "cde24766b3955ecff20836271e060c37.jpg";